<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>用户订单进度</span>
        </div>

        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <el-form-item label="开始日期" prop="title">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              style="width: 150px;"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item label="结束日期" prop="title">
            <el-date-picker
              v-model="queryParams.endDate"
              style="width: 150px;"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item label="用户ID" prop="id">
            <el-input
              v-model="queryParams.id"
              placeholder="请输入用户ID"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="SKU" prop="sku">
            <el-input
              v-model="queryParams.sku"
              style="width: 220px;"
              placeholder="请输入SKU"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="订单号" prop="lang">
            <el-input
              v-model="queryParams.lang"
              style="width: 220px;"
              placeholder="请输入订单号"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button :loading="loading" type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
            <el-button icon="el-icon-refresh" :loading="loading" size="mini" @click="exportData">导出</el-button>
          </el-form-item>
        </el-form>

        <el-table
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="date_time"
            label="时间"
            align="center"
          />
          <el-table-column
            prop="uid"
            label="用户ID"
            align="center"
          />
          <el-table-column
            prop="title"
            label="商品"
            align="center"
          >
            <template scope="{row}">
              <span v-if="row.title == '未匹配到'">{{ row.gid }}</span>
              <span v-else>{{ row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="sku"
            label="sku"
            align="center"
            width="250"
          />
          <el-table-column
            prop="orderPay"
            label="拉起支付"
            align="center"
          >
            <template scope="{row}">
              <span v-if="row.orderPay === '0'">否</span>
              <span v-else>成功</span>
            </template>

          </el-table-column>
          <el-table-column
            prop="payStatus"
            label="支付状态"
            align="center"
          >
            <template scope="{row}">
              <span v-if="row.payStatus === '1'">成功</span>
              <span v-else>失败</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="orderShip"
            label="请求发货"
            align="center"
          >
            <template scope="{row}">
              <i v-if="row.orderShip === '1'" class="el-icon-document-copy" @click="copyText(row.orderShipParam)" />
              <span v-if="row.orderShip === '0'">未请求</span>
              <span v-else>成功</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="orderShipStatus"
            label="发货状态"
            align="center"
          >
            <template scope="{row}">
              <i v-if="row.orderShipStatus === '1'" class="el-icon-document-copy" @click="copyText(row.orderShipStatusParam)" />
              <span v-if="row.orderShipStatus === '0'">-</span>
              <span v-else-if="row.orderShipStatus === '1'">成功</span>
              <span v-else>{{ row.orderShipStatus }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getUserOrderProcess } from '@/api/config/reward-record'
export default {
  name: 'UserOrderProcess',
  data() {
    return {
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        id: '',
        startDate: '',
        sku: '',
        lang: '',
        level: 0
      },
      loading: false,
      tableData: []
    }
  },
  created() {

  },
  methods: {
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleQuery() {
      if (this.queryParams.lang === '') {
        if (this.queryParams.startDate === '') {
          this.msgError('请选择开始日期')
          return
        }
        if (this.queryParams.endDate === '') {
          this.msgError('请选择结束日期')
          return
        }
        if (this.queryParams.id === '') {
          this.msgError('请输入用户UID')
          return
        }
      }

      this.getTables()
    },
    getTables() {
      this.queryParams.level = 0
      this.loading = true
      getUserOrderProcess(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData() {
      this.loading = true
      this.queryParams.level = 1
      getUserOrderProcess(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    copyText(textToCopy) {
      const input = document.createElement('textarea')
      input.style.position = 'fixed'
      input.style.opacity = '0'
      input.value = textToCopy
      document.body.appendChild(input)
      input.focus()
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success('拷贝成功')
    }
  }
}
</script>

<style scoped>
</style>
